import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { viewIdToPath } from '../router/routes';

/**
 * Drop-in replacement for the old `setCurrentView(viewId)` pattern.
 * Returns a function that accepts a view ID (e.g. 'calendar') and
 * navigates to the corresponding URL path ('/calendar').
 */
export function useAppNavigate() {
  const navigate = useNavigate();

  return useCallback(
    (viewId) => {
      const path = viewIdToPath[viewId] || `/${viewId}`;
      navigate(path);
    },
    [navigate]
  );
}
